import { coreApi } from '$api'
import { Budget } from '$models'
import { singletonQueryClient } from '$utils'

/**
 * Get a list of Budgets.
 * @returns Promise<Budget[]>
 */
export const getBudgets = async (
  from: string | undefined,
  to: string | undefined
): Promise<Budget[]> => {
  return singletonQueryClient.fetchQuery({
    queryKey: ['budgets', from, to],
    queryFn: async () => {
      return await coreApi.getBudgets(from, to)
    },
  })
}
